import { toast } from "react-toastify";
import { executeGET } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const CountryList = async (cb) => {
  try {
    const countrylist = await executeGET("/listofcountries");
    const CountryListData = countrylist.data ? countrylist.data : [];
    return CountryListData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
